import { apiSlice } from "features/api/apiSlice";

const createUrlFromBlob = (blob) => {
  return URL.createObjectURL(blob);
};

const getAppointmentFiles = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getAppointmentFiles: build.query({
      query: ({ id, type }) => ({
        url: `/appointments/download/${id}?type=${type}`,
        responseHandler: (response) => {
          return response.blob().then(createUrlFromBlob);
        },
      }),
    }),
  }),
});

export const { useGetAppointmentFilesQuery } = getAppointmentFiles;
